import { Factory } from 'rosie';

Factory.define('AgentProfileEditor').attr('name', 'AGENT_PROFILE_EDITOR');

Factory.define('AgentProfileEditorWithDefaults').extend('AgentProfileEditor');
